import { component } from "picoapp";
import { store } from "../../../../src/scripts/vue/config/store";

export const navigation = component((node: HTMLElement, context) => {
  // Elements
  const topNavHamburgerElement = node.querySelector(".js-hamburger-button");
  const topNavCloseElement = node.querySelector(".js-close-button");
  const mobileMainNavElement = node.querySelector(".js-mobile-main-nav");
  const dropdownLevelOneLinkElements = node.querySelectorAll(
    ".js-dropdown-level-1-link"
  );
  const dropdownLevelTwoCloseButtonElements = node.querySelectorAll(
    ".js-dropdown-level-2-close"
  );
  const navMainLinkElements = node.querySelectorAll(".js-main-nav-link");
  const desktopDropdownContentElements = node.querySelectorAll(
    ".js-desktop-nav-dropdown-content"
  );
  const dropdownLevelOneElement = node.querySelector(".js-dropdown-level-1");

  const cartButtonElements = node.querySelectorAll(".js-cart-button");

  const bodyElement = document.querySelector("body");

  // Handlers
  const openMobileDropdownHandler = () => {
    mobileMainNavElement.classList.remove("hidden");
    bodyElement.dataset.scrollY = window.scrollY.toString();
    bodyElement.classList.add("fixed", "overflow-y-hidden");
  };

  const closeMobileDropdownHandler = (e) => {
    bodyElement.classList.remove("fixed", "overflow-y-hidden");
    window.scroll({ top: parseInt(bodyElement.dataset.scrollY) });
    bodyElement.removeAttribute("data-scroll-y");
    closeMobileDropdownLevelTwoHandler(e);
    mobileMainNavElement.classList.add("hidden");
  };

  const cartClickHandler = (e) => {
    store.dispatch("cart/toggleCart");
    closeMobileDropdownHandler(e);
  };

  const openMobileDropdownLevelTwoHandler = (e) => {
    e.preventDefault();

    const dropdownLevelTwoElement = node.querySelector(
      `.js-dropdown-level-2[data-level-two-id=${e.currentTarget.dataset.levelTwoId}]`
    );
    dropdownLevelTwoElement.classList.remove("hidden");
    dropdownLevelOneElement.classList.add("hidden");
  };

  const closeMobileDropdownLevelTwoHandler = (e) => {
    e.preventDefault();
    node
      .querySelectorAll(".js-dropdown-level-2")
      .forEach((dropdownLevelTwo) => dropdownLevelTwo.classList.add("hidden"));
    dropdownLevelOneElement.classList.remove("hidden");
  };

  const openDesktopDropdownHandler = (e) => {
    const desktopNavDropdown = node.querySelector(
      `.js-desktop-nav-dropdown[data-dropdown-id=${e.currentTarget.dataset.dropdownId}]`
    );

    desktopNavDropdown.classList.remove("hidden");
  };

  const closeDesktopDropdownHandler = (e) => {
    const desktopNavDropdown = node.querySelector(
      `.js-desktop-nav-dropdown[data-dropdown-id=${e.currentTarget.dataset.dropdownId}]`
    );

    desktopNavDropdown.classList.add("hidden");
  };

  const closeAllDesktopDropdownHandler = () => {
    const allDesktopNavDropdowns = node.querySelectorAll(
      ".js-desktop-nav-dropdown"
    );

    allDesktopNavDropdowns.forEach((navDropdown) =>
      navDropdown.classList.add("hidden")
    );
  };

  const desktopDropdownTabbingHandler = (e) => {
    if (e.which === 13) {
      e.preventDefault();
      const desktopNavDropdown = node.querySelector(
        `.js-desktop-nav-dropdown[data-dropdown-id=${e.currentTarget.dataset.dropdownId}]`
      );

      if (desktopNavDropdown.classList.contains("hidden")) {
        closeAllDesktopDropdownHandler();
        openDesktopDropdownHandler(e);
      } else {
        closeDesktopDropdownHandler(e);
      }
    }
  };

  // Setup Listeners
  topNavHamburgerElement.addEventListener("click", openMobileDropdownHandler);
  topNavCloseElement.addEventListener("click", closeMobileDropdownHandler);

  [...navMainLinkElements, ...desktopDropdownContentElements].forEach(
    (link) => {
      link.addEventListener("mouseenter", openDesktopDropdownHandler);
      link.addEventListener("mouseleave", closeDesktopDropdownHandler);
    }
  );

  navMainLinkElements.forEach((link) =>
    link.addEventListener("keydown", desktopDropdownTabbingHandler)
  );

  dropdownLevelOneLinkElements.forEach((link) =>
    link.addEventListener("click", openMobileDropdownLevelTwoHandler)
  );
  dropdownLevelTwoCloseButtonElements.forEach((button) =>
    button.addEventListener("click", closeMobileDropdownLevelTwoHandler)
  );

  cartButtonElements.forEach((icon) => {
    icon.addEventListener("click", cartClickHandler);
  });

  context.on("cart:updated", (payload) => {
    if (payload.item_count > 0) {
      cartButtonElements.forEach((button) => {
        button.querySelector(".js-cart-bubble").classList.remove("hidden");
        button.querySelector(".js-cart-count").children[0].innerHTML =
          payload.item_count;
      });
    } else {
      cartButtonElements.forEach((button) => {
        button.querySelector(".js-cart-bubble").classList.add("hidden");
      });
    }
  });

  return (node: HTMLButtonElement) => {
    topNavHamburgerElement.removeEventListener(
      "click",
      openMobileDropdownHandler
    );
    topNavCloseElement.removeEventListener("click", closeMobileDropdownHandler);
    [...navMainLinkElements, ...desktopDropdownContentElements].forEach(
      (link) => {
        link.removeEventListener("mouseenter", openDesktopDropdownHandler);
        link.removeEventListener("mouseleave", closeDesktopDropdownHandler);
      }
    );
    navMainLinkElements.forEach((link) => {
      link.removeEventListener("click", desktopDropdownTabbingHandler);
    });
    dropdownLevelOneLinkElements.forEach((link) =>
      link.removeEventListener("click", openMobileDropdownLevelTwoHandler)
    );
    dropdownLevelTwoCloseButtonElements.forEach((button) =>
      button.removeEventListener("click", closeMobileDropdownLevelTwoHandler)
    );
    cartButtonElements.forEach((button) => {
      button.removeEventListener("click", cartClickHandler);
    });
  };
});
